// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      // eslint-disable-next-line react/jsx-indent
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/c/:type/:slug/:articleGUID',
    channel: null,
    varnish: true
  },
});
